import type { IconSvgObject } from './types';

const ArrowUpAzIcon: IconSvgObject = [
  ["path", { d: "M3.75 8L7.75 4L11.75 8M7.75 5V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.25 8H19.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.25 10L18.4081 4.47434C18.3137 4.19107 18.0486 4 17.75 4C17.4514 4 17.1863 4.19107 17.0919 4.47434L15.25 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.75 14H19.75L15.75 20H19.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ArrowUpAzIcon;
